import * as React from 'react';
import { BrowserRouter, Route, Link, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Translate from '../../common/functions/translate';
import AuthService from '../../services/authService';
import HomeComponent from "../home/home";
import MedicinesContainer from '../medicines/medicinesContainer';
import MedicineDetails from '../medicines/medicineDetails';
import LoginComponent from '../login/loginComponent';
import ForgotPasswordComponent from '../login/forgotPasswordComponent';
import CreateNewAccountComponent from '../login/createNewAccountComponent';
import CookiePolicyComponent from '../pages/cookiePolicyComponent';
import PersonalDataPolicyComponent from '../pages/personalDataPolicyComponent';
import UserProfileComponent from '../user/userProfile/userProfileComponent';
import UserMedicinesComponent from '../user/userMedicines/userMedicinesComponent';
import UserDiseasesComponent from '../user/userDiseases/userDiseasesComponent';
import UserPrescriptionComponent from '../user/userPrescriptions/userPrescriptionComponent';
import NewPasswordComponent from '../login/newPasswordComponent';
import NotAuthenticatedComponent from '../pages/notAuthenticatedComponent';
import UserFamilyComponent from '../user/userFamily/userFamilyComponent';
import InteractionsComponent from '../interactions/interactionsComponent';
import UserConditionComponent from '../user/userCondition/userConditionComponent';
import SettingsComponent from '../settings/settingsComponent';
import TestComponent from '../test/testComponent';
import UserNotificationList from '../user/userNotification/userNotificationList';
import DiseasesComponent from '../diseases/diseaseComponent';
import DisposalPlacesContainer from '../disposalPlaces/disposalPlacesContainer';
import ConfirmContainer from '../login/confirmContainer';
import ChatMobileComponent from '../chatBot/chatMobileComponent';
import LaboratoryResultsComponent from '../user/laboratoryResults/laboratoryResultsComponent';
import UserDashboardComponent from '../user/userDashboard/userDashboard';

const NoMatch = () => (
  <div className="app-content">
    <h3>
      URL address <code>{location.pathname}</code> not match.
    </h3>
  </div>
);

interface IProps {
  isUserLogged: boolean;
}

interface IState {
}

class Content extends React.Component<IProps, IState> {

  аuthService = new AuthService();

  constructor(props: IProps) {
    super(props);
  }

  public render() {

    return (
      <>
        <Switch>
          <Route exact path="/" component={HomeComponent} />
          <Route exact path="/index.html" component={HomeComponent} />

          <Route exact path="/cookie-policy" component={CookiePolicyComponent} />
          <Route exact path="/personal-data-policy" component={PersonalDataPolicyComponent} />

          {/* Medicines  */}
          <Route exact path="/medicines" component={MedicinesContainer} />
          <Route exact path="/diseases" component={DiseasesComponent} />
          <Route exact path="/medicines/:MedicineId" component={MedicineDetails} />
          <Route exact path="/medicines/:MedicineId/:TabName" component={MedicineDetails} />
          <Route exact path="/medicines/:MedicineId/:TabName/:InteractionType" component={MedicineDetails} />

          {/* Interactions  */}
          <Route exact path="/interactions" component={InteractionsComponent} />

          {/* DisposalPlaces  */}
          <Route exact path="/disposal-places" component={DisposalPlacesContainer} />

          {/* Login  */}
          <Route exact path="/login" component={LoginComponent} />
          <Route exact path="/create-new-account" component={CreateNewAccountComponent} />
          <Route exact path="/new-password" component={NewPasswordComponent} />
          <Route exact path="/forgot-password" component={ForgotPasswordComponent} />
          <Route exact path="/confirm-container" component={ConfirmContainer} />

          {/* Settings  */}
          <Route exact path="/settings" component={SettingsComponent} />

          {/* Test  */}
          <Route exact path="/test" component={TestComponent} />

          {/* Test  */}
          <Route exact path="/chatbot" component={ChatMobileComponent} />

          {/* User  */}
          <Route exact path="/user/profile"
            component={this.аuthService.isAuthenticated() ? UserProfileComponent : NotAuthenticatedComponent} />
          <Route exact path="/user/family"
            component={this.аuthService.isAuthenticated() ? UserFamilyComponent : NotAuthenticatedComponent} />
          <Route exact path="/user/medicines"
            component={this.аuthService.isAuthenticated() ? UserMedicinesComponent : NotAuthenticatedComponent} />
          <Route exact path="/user/diseases"
            component={this.аuthService.isAuthenticated() ? UserDiseasesComponent : NotAuthenticatedComponent} />
          <Route exact path="/user/prescriptions"
            component={this.аuthService.isAuthenticated() ? UserPrescriptionComponent : NotAuthenticatedComponent} />
          <Route exact path="/user/condition"
            component={this.аuthService.isAuthenticated() ? UserConditionComponent : NotAuthenticatedComponent} />
          <Route exact path="/user/notifications"
            component={this.аuthService.isAuthenticated() ? UserNotificationList : NotAuthenticatedComponent} />
          <Route exact path="/user/labresults"
            component={this.аuthService.isAuthenticated() ? LaboratoryResultsComponent : NotAuthenticatedComponent} />
          <Route exact path="/user/dashboard"
            component={this.аuthService.isAuthenticated() ? UserDashboardComponent : NotAuthenticatedComponent} />

          <Route component={NoMatch} />
        </Switch>

      </>

    )
  }
}


const mapsStateToProps = state => {
  return {
    isUserLogged: state.common.isUserLogged
  };
}

export default connect(mapsStateToProps, null)(Content);